// extracted by mini-css-extract-plugin
export var afterFooter = "Footer-module--afterFooter--a24ed";
export var brand = "Footer-module--brand--dea53";
export var brandCol = "Footer-module--brandCol--e0a7a";
export var brandContact = "Footer-module--brandContact--a7527";
export var brandContactContent = "Footer-module--brandContactContent--f35a1";
export var brandDescription = "Footer-module--brandDescription--7f027";
export var brandLink = "Footer-module--brandLink--70772";
export var contactCol = "Footer-module--contactCol--ded3c";
export var footer = "Footer-module--footer--2d913";
export var footerWrapper = "Footer-module--footerWrapper--0a310";
export var logo = "Footer-module--logo--2eef9";
export var logoIcon = "Footer-module--logo-icon--a517f";
export var nav = "Footer-module--nav--fce49";
export var navCol = "Footer-module--navCol--5faf1";
export var social = "Footer-module--social--6e211";